import React from "react";
import { useNavigate } from "react-router-dom";

export const Schedule = () => {
  const navigate = useNavigate();

  const styles = {
    timetable: {
      border: "none",
      borderBottom: "1px solid black",
    },
    timetableColumn: {
      width: "16.6%",
      border: "none",
    },
    workshop: {
      backgroundColor: "lightblue",
      border: "none",
      borderRight: "1px solid black",
      width: "16.6%",
    },
    break: {
      backgroundColor: "violet",
      border: "none",
      width: "16.6%",
      borderRight: "1px solid black",
    },
    phdForum: {
      backgroundColor: "pink",
      width: "16.6%",
      border: "none",
      borderRight: "1px solid black",
    },
    welcome: {
      backgroundColor: "#EEE82C",
      width: "16.6%",
      border: "none",
      borderRight: "1px solid black",
    },
    keynote: {
      backgroundColor: "#B8B42D",
      width: "16.6%",
      border: "none",
      borderRight: "1px solid black",
    },
    sessions: {
      backgroundColor: "#D0FEF5",
      width: "16.6%",
      border: "none",
      borderRight: "1px solid black",
    },
    poster: {
      backgroundColor: "#FFC6AC",
      width: "16.6%",
      border: "none",
      borderRight: "1px solid black",
    },
    panel: {
      backgroundColor: "#FF934F",
      width: "16.6%",
      border: "none",
      borderRight: "1px solid black",
    },
    rowWorkshop: {
      border: "none",
      width: "16.6%",
    },
  };

  return (
    <>
      <table style={styles.timetable}>
        <tr style={{ border: "none" }}>
          <th></th>

          <th>Monday</th>
          <th>Monday</th>
          <th>Tuesday</th>
          <th>Wednesday</th>
          <th>Thursday</th>
        </tr>
        <tr style={{ border: "none" }}>
          <td>9:00-9:30</td>
          <td style={styles.workshop}>Workshops at MTU</td>
          <td style={styles.phdForum}>PhD Forum at UCC</td>
          <td style={styles.welcome}>Conference Welcome</td>
          <td style={{ border: "none", borderRight: "1px solid black" }}></td>
          <td style={styles.panel}>Panel</td>
        </tr>
        <tr style={{ border: "none" }}>
          <td>9:30-10:00</td>
          <td style={styles.workshop}></td>
          <td style={styles.phdForum}></td>
          <td style={styles.keynote}>Keynote: Akane Sano</td>
          <td style={styles.keynote}>Keynote: Vinny Cahill</td>
          <td style={styles.panel}></td>
        </tr>
        <tr style={{ border: "none" }}>
          <td>10:00-10:30</td>
          <td style={styles.workshop}></td>
          <td style={styles.phdForum}></td>
          <td style={styles.keynote}></td>
          <td style={styles.keynote}></td>
          <td style={styles.panel}></td>
        </tr>
        <tr style={{ border: "none" }}>
          <td>10:30-11:00</td>
          <td style={styles.workshop}></td>
          <td style={styles.phdForum}></td>
          <td style={styles.break}>Coffee Break</td>
          <td style={styles.break}>Coffee Break</td>
          <td style={styles.break}>Coffee Break</td>
        </tr>
        <tr style={{ border: "none" }}>
          <td>11:00-11:30</td>
          <td style={styles.workshop}></td>
          <td style={styles.phdForum}></td>
          <td style={styles.sessions}>
            Session 1 - Energy-aware Smart Systems
          </td>
          <td style={styles.sessions}>Session 3 - Best Papers</td>
          <td style={styles.sessions}>
            Session 6 -Learning, Sensing, and Orchestration
          </td>
        </tr>
        <tr style={{ border: "none" }}>
          <td>11:30-12:00</td>
          <td style={styles.workshop}></td>
          <td style={{ border: "none", borderRight: "1px solid black" }}></td>
          <td style={styles.sessions}></td>
          <td style={styles.sessions}></td>
          <td style={styles.sessions}></td>
        </tr>
        <tr style={{ border: "none" }}>
          <td>12:00-12:30</td>
          <td style={styles.workshop}></td>
          <td style={{ border: "none", borderRight: "1px solid black" }}></td>
          <td style={styles.sessions}></td>
          <td style={styles.sessions}></td>
          <td style={styles.sessions}></td>
        </tr>
        <tr style={{ border: "none" }}>
          <td>12:30-13:00</td>
          <td style={styles.workshop}></td>
          <td style={{ border: "none", borderRight: "1px solid black" }}></td>
          <td style={styles.break}>Lunch</td>
          <td style={styles.break}>Lunch</td>
          <td style={styles.break}>Lunch</td>
        </tr>
        <tr style={{ border: "none" }}>
          <td>13:00-13:30</td>
          <td style={styles.break}>Lunch</td>
          <td style={{ border: "none", borderRight: "1px solid black" }}></td>
          <td style={styles.break}></td>
          <td style={styles.break}></td>
          <td style={styles.break}></td>
        </tr>

        <tr style={{ border: "none" }}>
          <td>13:30-14:00</td>
          <td style={styles.break}></td>
          <td style={{ border: "none", borderRight: "1px solid black" }}></td>
          <td style={styles.sessions}>Session 2 - Industry Paper Session</td>
          <td style={styles.sessions}>
            Session 4 - Intelligent Transportation Systems
          </td>
          <td style={styles.sessions}>
            Session 7 - Smart Multimodal Computing for Behavioural Insights
          </td>{" "}
        </tr>
        <tr style={{ border: "none" }}>
          <td>14:00-14:30</td>
          <td style={styles.workshop}>Workshops at MTU</td>
          <td style={{ border: "none", borderRight: "1px solid black" }}></td>
          <td style={styles.sessions}></td>
          <td style={styles.sessions}></td>
          <td style={styles.sessions}></td>
        </tr>
        <tr style={{ border: "none" }}>
          <td>14:30-15:00</td>
          <td style={styles.workshop}></td>
          <td style={{ border: "none", borderRight: "1px solid black" }}></td>
          <td style={styles.sessions}></td>
          <td style={styles.sessions}></td>
          <td style={styles.sessions}></td>
        </tr>
        <tr style={{ border: "none" }}>
          <td>15:00-15:30</td>
          <td style={styles.workshop}></td>
          <td style={{ border: "none", borderRight: "1px solid black" }}></td>
          <td style={styles.break}>Coffee Break</td>
          <td style={styles.break}>Coffee Break</td>
          <td style={styles.break}>Coffee Break</td>
        </tr>
        <tr style={{ border: "none" }}>
          <td>15:30-16:00</td>
          <td style={styles.workshop}></td>
          <td style={{ border: "none", borderRight: "1px solid black" }}></td>
          <td style={styles.poster}>Poster/Demo Session</td>
          <td style={styles.sessions}>Session 5 - Smart Modelling of CPS</td>
          <td style={styles.welcome}>Conference Close</td>
        </tr>
        <tr style={{ border: "none" }}>
          <td>16:00-16:30</td>
          <td style={styles.workshop}></td>
          <td style={{ border: "none", borderRight: "1px solid black" }}></td>
          <td style={styles.poster}></td>
          <td style={styles.sessions}></td>
          <td style={{ border: "none", borderRight: "1px solid black" }}></td>
        </tr>
        <tr style={{ border: "none" }}>
          <td>16:30-17:00</td>
          <td style={styles.workshop}></td>
          <td style={{ border: "none", borderRight: "1px solid black" }}></td>
          <td style={styles.poster}></td>
          <td style={styles.sessions}></td>
          <td style={{ border: "none", borderRight: "1px solid black" }}></td>
        </tr>
      </table>
    </>
  );
};
